import { Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import DatePicker from "react-datepicker";
import ReCAPTCHA from "react-google-recaptcha";
import SectionSeparator from "../SectionSeparator";
import SubSectionSeparator from "../SubSectionSeparator";

const StudentDetailsStep = ({ ctx }) => {
  const {
    recaptcha,
    formData,
    setFormData,
    errors,
    countries,
    handleChange,
    STORAGE_URL,
  } = ctx;

  return (
    <>
      <Row alignItems={"center"}>
        <Col md={6} lg={3} xl={4} xxl={2}>
          <div
            className="d-flex justify-content-center align-items-center mb-2"
            style={{ height: 150 }}
          >
            <img
              src={`${STORAGE_URL}${formData.centerData.center_uuid}/children/${formData.childData.picture}`}
              alt=""
              className="img-fluid"
              style={{
                maxHeight: 140,

                objectFit: "contain",
              }}
            />
          </div>
        </Col>

        <Col md={6} lg={3} xxl={2} className="d-flex align-items-center"></Col>

        <Col
          md={12}
          xl={8}
          className="ml-lg-auto d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-end gap-5 flex-column-reverse mt-5 lg:mt-3"
        >
          <ReCAPTCHA
            ref={recaptcha}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          />
        </Col>
      </Row>

      <SectionSeparator title="title.child_details" />

      <Row>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>

            <FormattedMessage id="child_first_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.childData.child_name}
                  placeholder={placeholder}
                  type="text"
                  name="child_name"
                  onChange={(e) => handleChange(e, "child")}
                  isInvalid={!!errors.child_name}
                  disabled={true}
                />
              )}
            </FormattedMessage>

            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.child_name" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>

            <FormattedMessage id="birth_date">
              {(placeholder) => (
                <DatePicker
                  placeholderText={placeholder}
                  className={
                    errors.birth_date
                      ? " form-control is-invalid"
                      : "form-control"
                  }
                  selected={formData.childData.birth_date}
                  onChange={(date) =>
                    setFormData((prevData) => ({
                      ...prevData,

                      childData: {
                        ...prevData.childData,

                        birth_date: date,
                      },
                    }))
                  }
                  dateFormat="dd/MM/yyyy"
                  disabled={true}
                />
              )}
            </FormattedMessage>

            <div className={errors.birth_date ? "is-invalid" : ""}></div>

            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.birth_date" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/*
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="birth_city">
              {(placeholder) => (
                <Form.Control
                  value={formData.childData.birth_city}
                  placeholder={placeholder}
                  type="text"
                  name="birth_city"
                  onChange={(e) => handleChange(e, "child")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>

            <Form.Select
              name="gender"
              onChange={(e) => handleChange(e, "child")}
              value={formData.childData.gender}
              isInvalid={!!errors.gender}
            >
              <option value="">
                <FormattedMessage id="select_gender" />
              </option>

              <option value="F">
                <FormattedMessage id="female" />
              </option>

              <option value="M">
                <FormattedMessage id="male" />
              </option>
            </Form.Select>

            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.gender" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>

            <Form.Select
              onChange={(e) => handleChange(e, "child")}
              name="country_id"
              value={formData.childData.country_id}
              isInvalid={!!errors.country_id}
              disabled={true}
            >
              <option value="">
                <FormattedMessage id="select_nationality" />
              </option>

              {countries?.map((country, index) => (
                <option key={index} value={country.country_id}>
                  {country.country_name}
                </option>
              ))}
            </Form.Select>

            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.country_id" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>

            <FormattedMessage id="id_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.childData.id_number}
                  placeholder={placeholder}
                  type="text"
                  name="id_number"
                  onChange={(e) => handleChange(e, "child")}
                  isInvalid={!!errors.id_number}
                />
              )}
            </FormattedMessage>

            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.id_number" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="passport_num">
              {(placeholder) => (
                <Form.Control
                  value={formData.childData.passport_number}
                  placeholder={placeholder}
                  type="text"
                  name="passport_number"
                  onChange={(e) => handleChange(e, "child")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="passport_validity">
              {(placeholder) => (
                <DatePicker
                  placeholderText={placeholder}
                  className={
                    errors?.passport_validity
                      ? " form-control is-invalid"
                      : "form-control"
                  }
                  selected={formData.childData.passport_validity}
                  onChange={(date) =>
                    setFormData((prevData) => ({
                      ...prevData,

                      childData: {
                        ...prevData.childData,

                        passport_validity: date,
                      },
                    }))
                  }
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        {/*
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="residency_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.childData.residency_number}
                  placeholder={placeholder}
                  type="text"
                  name="residency_number"
                  onChange={(e) => handleChange(e, "child")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}

        {/*
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="residency_validity">
              {(placeholder) => (
                <DatePicker
                  placeholderText={placeholder}
                  className={
                    errors.residency_validity
                      ? " form-control is-invalid"
                      : "form-control"
                  }
                  selected={formData.childData.residency_validity}
                  onChange={(date) =>
                    setFormData((prevData) => ({
                      ...prevData,

                      childData: {
                        ...prevData.childData,

                        residency_validity: date,
                      },
                    }))
                  }
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}
      </Row>

      <SectionSeparator title="title.family_details" />

      <SubSectionSeparator title="title.sponsor_parent_information" />

      <Row>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="id_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.id_number ?? ""}
                  required
                  placeholder={placeholder}
                  type="text"
                  name="id_number"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.parent_id_number}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.id_number" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="full_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.sponsor_name}
                  placeholder={placeholder}
                  type="text"
                  name="sponsor_name"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.sponsor_name}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="email_address">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.email1}
                  required
                  placeholder={placeholder}
                  type="text"
                  name="email1"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.email1}
                />
              )}
            </FormattedMessage>
            <span className="required-field">*</span>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.email" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="mobile_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.phone1}
                  placeholder={placeholder}
                  type="text"
                  name="phone1"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.phone1}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="home_address">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.address}
                  placeholder={placeholder}
                  type="text"
                  name="address"
                  onChange={(e) => handleChange(e, "parent")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        {/*
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="education">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.parent_education_level}
                  placeholder={placeholder}
                  type="text"
                  name="parent_education_level"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.parent_education_level}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}

        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="place_of_work">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.employer_father}
                  placeholder={placeholder}
                  type="text"
                  name="employer_father"
                  onChange={(e) => handleChange(e, "parent")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        {/*
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="occupation">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.position_id_father}
                  placeholder={placeholder}
                  type="text"
                  name="position_id_father"
                  onChange={(e) => handleChange(e, "parent")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}

        {/*
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="grandfather_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.grandfather}
                  placeholder={placeholder}
                  type="text"
                  name="grandfather"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.grandfather}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}
      </Row>

      <SubSectionSeparator title="title.spouse_information" />

      <Row>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <span className="required-field">*</span>
            <FormattedMessage id="id_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.spouse_id_number ?? ""}
                  required
                  placeholder={placeholder}
                  type="text"
                  name="spouse_id_number"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.spouse_id_number}
                />
              )}
            </FormattedMessage>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.id_number" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="full_name">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.spouse_name}
                  placeholder={placeholder}
                  type="text"
                  name="spouse_name"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.spouse_name}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="email_address">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.spouse_email}
                  required
                  placeholder={placeholder}
                  type="text"
                  name="spouse_email"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.spouse_email}
                />
              )}
            </FormattedMessage>
            <span className="required-field">*</span>
            <Form.Control.Feedback className="px-3" type="invalid">
              <FormattedMessage id="error.email" />
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="mobile_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.spouse_phone}
                  placeholder={placeholder}
                  type="text"
                  name="spouse_phone"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.spouse_phone}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <Form.Select
              onChange={(e) => handleChange(e, "parent")}
              name="spouse_country"
              value={formData.parentData.spouse_country}
              isInvalid={!!errors.spouse_country}
            >
              <option value="">
                <FormattedMessage id="select_nationality" />
              </option>

              {countries?.map((country, index) => (
                <option key={index} value={country.mother_nationality}>
                  {country.country_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {/*
        <Col md={3}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="education">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.spouse_education_level}
                  placeholder={placeholder}
                  type="text"
                  name="spouse_education_level"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.spouse_education_level}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}

        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="place_of_work">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.employer_mother}
                  placeholder={placeholder}
                  type="text"
                  name="employer_mother"
                  onChange={(e) => handleChange(e, "parent")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        {/*
        <Col md={3}>
          <Form.Group className="mb-4">
            <FormattedMessage id="occupation">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.position_id_mother}
                  placeholder={placeholder}
                  type="text"
                  name="position_id_mother"
                  onChange={(e) => handleChange(e, "parent")}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        */}
      </Row>

      <SectionSeparator title="title.emergency_contact" />

      <Row>
        <Col md={4}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="name">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.emergency_contact_name}
                  placeholder={placeholder}
                  type="text"
                  name="emergency_contact_name"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.emergency_contact_name}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="relation">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.emergency_contact_relation}
                  placeholder={placeholder}
                  type="text"
                  name="emergency_contact_relation"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.emergency_contact_relation}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group className="mb-4 position-relative">
            <FormattedMessage id="contact_number">
              {(placeholder) => (
                <Form.Control
                  value={formData.parentData.emergency_phone1}
                  placeholder={placeholder}
                  type="text"
                  name="emergency_phone1"
                  onChange={(e) => handleChange(e, "parent")}
                  isInvalid={!!errors.emergency_phone1}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default StudentDetailsStep;
